import { Component, OnInit } from '@angular/core';
import {FormBuilder, FormControl, FormGroup, Validators} from '@angular/forms';
import {RealmService} from '../Services/Realm/realm.service';
import {ApiService} from '../Services/Api/api.service';
import {SessionService} from '../Services/Session/session-service.service';
import {FirebaseService} from '../Services/Firebase/firebase.service';
import {AuthService} from '../auth.service';
import {Router} from '@angular/router';
import {ConfirmationService, MessageService} from 'primeng/api';
import { DatePipe } from '@angular/common';
import {environment} from '../../environments/environment';

@Component({
  selector: 'app-forgot-id',
  templateUrl: './forgot-id.component.html',
  styleUrls: ['./forgot-id.component.css','../../assets/layout/style/layout.css']
})

export class ForgotIdComponent implements OnInit {
  types = [];
  userform: FormGroup;
  submitted: boolean;
  items: any[];
  countryTitle: string;
  selectedCity: string;
  phoneTitle: string;
  emailTitle: string;
  dpiTitle: string;
  loginBtnTitle: string;
  fcmToken: string;
  masks = 'dd/MM/yyyy';
  selectedType = 0;
  sessionResponse: any;
  yearRange: string;
  product: any = [];
  selectedProducts: any[];
  env = environment;
  idCardNumber: string = '';
  success: boolean = false;


  constructor(private realm: RealmService, private api: ApiService, private st: SessionService,
              private Rc: FirebaseService, private fb: FormBuilder, private auth: AuthService,
              private router: Router, private messageService: MessageService, private confirmationService: ConfirmationService, private dp: DatePipe) {
  }

  ngOnInit() {
    
    this.yearRange = `${new Date().getFullYear() - 120}:${new Date().getFullYear()}`;
    this.types = [];
    this.types.push({ label: 'Actualizar Datos', value: 0 });
    this.types.push({ label: 'Sesiones Activas', value: 1 });
    
    this.Rc.fetchActivate().then(() => {
      //console.log('pais:::::: ', this.Rc.getStringRC('global_select_country_title'));
      this.phoneTitle = this.Rc.getStringRC('global_phone_number');
      this.dpiTitle = this.Rc.getStringRC('global_number_id');
      this.emailTitle = this.Rc.getStringRC('global_email_address');
      this.loginBtnTitle = this.Rc.getStringRC('global_accept');
      this.countryTitle = this.Rc.getStringRC('global_select_country_title');
    });
    
    this.realm.getCountriesArea().then((data:any) => {
      this.items = data.data.countryCodeAppSettingsOrms;
    })
    
    this.userform = this.fb.group({
      phoneNumber: new FormControl('', [Validators.required, Validators.minLength(4)]),
      dpi: new FormControl('', Validators.required),
      email: new FormControl('', Validators.required),
      country: new FormControl('', Validators.required),
      name: new FormControl('', Validators.required),
      birthdate: new FormControl('', Validators.required),
      countrySelected: new FormControl('', Validators.required),
      lastName: new FormControl('', Validators.required),
    });
    this.selectedCity = this.userform.get('country').value;
  }
  ngAfterViewInit() {
    console.log("afterViewInit");
    

    
    this.api.responseApiForgotId$
      .subscribe(data => {
        //console.log('data ws: ', data);
        const dat = JSON.parse(JSON.stringify(data));
        if (data !== undefined) {
          this.env.isContentLoading = false;
        }
        if (dat.code === 701) {
          this.messageService.add({severity: 'success', summary: 'Exito', detail: 'Se ha procesado con éxito la petición.', sticky: false});
          this.setvalues();
          //this.router.navigate(['/login']);
        } else {
          this.messageService.add({severity: 'error', summary: 'error', detail: this.Rc.getStringRC('global_message_' + dat.code), sticky: false});
        }
      });
  }

  formatDates(items:any) {
    items.map( (item:any) => {
      if (item.logs[0].date !== undefined) {
        let myDatePayment = item.logs[0].date.replace(/(\d{2})\/(\d{2})\/(\d{4})/, "$2/$1/$3");
        item.logs[0].date = this.dp.transform(myDatePayment, 'yyyy-MM-ddThh:mm', 'es-ES');
      }
    });
    this.sessionResponse = items;
    //console.log("---- response ws: ----LIMPIO  ",this.sessionResponse);
  }

  test(event: any) {
    this.selectedType = event.option.value;
    if (this.selectedType === 1) {
      this.realm.getSessionSettings();
    }
  }
  setvalues() {
    const t =  this.items[0];
    this.userform.reset();
  }
  onSubmit(value: string) {
    this.env.isContentLoading = true;
    this.submitted = true;
    const q = JSON.parse(JSON.stringify(value));
    //console.log(q);
    let documentId = q.dpi;
    let email = q.email;
    let phoneNumber = q.country.idCode + "" + q.phoneNumber;
    let portalAllowed = "RPN";
    
    let completeName = q.name + q.lastName;
    let countryCode = q.countrySelected.idCode;
    let firstName = q.name;
    let lastName = q.lastName;

    //console.log("countryCode: "+countryCode);
    if (countryCode == "+502") {
      //console.log("CONSUME API DE TS");
      let birthdate = this.dp.transform(q.birthdate, 'yyyy-MM-dd', 'es-ES');
      this.realm.forgotIdPostTS(502, firstName, lastName, birthdate, documentId, email, phoneNumber).then((result:any) => {
        this.env.isContentLoading = false;
        if ( result != null ) {
          this.idCardNumber = result.carne;
          this.success = true;
        } else {
          this.messageService.add({severity: 'error', summary: 'error', detail: 'No se pudo identificar al asegurado.', sticky: false});
        }
       });
    } else {
      //console.log("CONSUME API DE MEDI");
      let birthdate = this.dp.transform(q.birthdate, 'dd/MM/yyyy', 'es-ES');
      this.realm.forgotIdPost(documentId, email, phoneNumber, portalAllowed, birthdate, completeName);
    }
  }

  onKeyDate(event: any) {
    event.target.value = event.target.value.replace(/^(\d{2})(\d{2})/, '$1/$2/');
    //console.log(event.target.value);
  }

  validate(evt) {
    var theEvent = evt || window.event;
    // Handle paste
    if (theEvent.type === 'paste') {
        //key = event.clipboardData.getData('text/plain');
    } else {
    // Handle key press
        var key = theEvent.keyCode || theEvent.which;
        key = String.fromCharCode(key);
    }
    var regex = /[0-9]|\./;
    if( !regex.test(key) ) {
      theEvent.returnValue = false;
      if(theEvent.preventDefault) theEvent.preventDefault();
    }
  }

  navigateComponent(url: string) {
    switch (url) {
      case 'login': {
        this.router.navigate(['login']);
        break;
      }
    }
  }

}

